/* HOOT — Homepage interactions
   - Live local clock in hero
   - Day/night slider on signature section
   - Lights-off toggle (global)
   - Auto-night between 00:00 and 06:00 (local viewer time)
*/
(function () {
  'use strict';

  // ---- Guard contre double initialisation ----
  if (window.__hootInit) return;
  window.__hootInit = true;

  // ---- Auto night between 00h and 06h (local time) ----
  function applyAutoNight() {
    var h = new Date().getHours();
    if (h >= 0 && h < 6) {
      document.body.classList.add('hoot-lights-off');
    }
  }

  // ---- Lights-off toggle ----
  function initLightsToggle() {
    var btn = document.querySelector('.hoot-lights-toggle');
    if (!btn) return;

    var label = btn.querySelector('.hoot-lights-toggle__label');

    function updateLabel() {
      if (!label) return;
      var isOff = document.body.classList.contains('hoot-lights-off');
      label.textContent = isOff
        ? (label.dataset.off || 'LIGHTS OFF')
        : (label.dataset.on || 'LIGHTS ON');
    }

    // Supprime les anciens listeners en clonant le bouton
    var newBtn = btn.cloneNode(true);
    btn.parentNode.replaceChild(newBtn, btn);
    label = newBtn.querySelector('.hoot-lights-toggle__label');

    newBtn.addEventListener('click', function () {
      document.body.classList.toggle('hoot-lights-off');
      updateLabel();
    });

    updateLabel();
  }

  // ---- Live local clock (hero) ----
  function initClock() {
    var els = document.querySelectorAll('[data-hoot-clock]');
    if (!els.length) return;

    function tick() {
      var d = new Date();
      var hh = String(d.getHours()).padStart(2, '0');
      var mm = String(d.getMinutes()).padStart(2, '0');
      var ss = String(d.getSeconds()).padStart(2, '0');
      els.forEach(function (el) {
        el.innerHTML = hh + ':' + mm + ':<span class="hoot-accent">' + ss + '</span>';
      });
    }

    tick();
    if (!window.__hootClockInterval) {
      window.__hootClockInterval = setInterval(tick, 1000);
    }
  }

  // ---- Day/night slider ----
  function initDayNightSlider() {
    var range = document.querySelector('[data-hoot-darkness]');
    if (!range) return;

    var dial = document.querySelector('[data-hoot-darkness-dial]');
    var pct  = document.querySelector('[data-hoot-darkness-pct]');

    function update() {
      var v = parseInt(range.value, 10) / 100;
      if (pct) pct.textContent = Math.round((1 - v) * 100);
      if (dial) {
        if (v > 0.4) dial.classList.add('hoot-dial--lit');
        else dial.classList.remove('hoot-dial--lit');
      }
    }

    range.addEventListener('input', update);
    update();
  }

  function init() {
    applyAutoNight();
    initLightsToggle();
    initClock();
    initDayNightSlider();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
